import React from 'react';
import { Card, Switch, Space, Button, Typography } from 'antd';

const { Text } = Typography;

const Desktop = ({ viewModel }) => {
    const { enabled, setEnabled, onSave } = viewModel;

    return (
        <Card title="Cấu hình bảng giá khách hàng" style={{ maxWidth: 600 }}>
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                <Space>
                    <Switch checked={enabled} onChange={setEnabled} />
                    <Text>{enabled ? 'Đã bật' : 'Đã tắt'}</Text>
                </Space>
                <Text type="secondary">
                    Khi bật, hệ thống cho phép gán bảng giá riêng cho từng khách hàng.
                    Giá sản phẩm sẽ được tính theo bảng giá của khách hàng thay vì giá mặc định.
                </Text>
                <Button type="primary" onClick={onSave}>Lưu</Button>
            </Space>
        </Card>
    );
};

export default Desktop;
